"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMetadata = void 0;
const browser_headers_1 = require("browser-headers");
const getMetadata = (params) => {
    const metadata = new browser_headers_1.BrowserHeaders();
    for (const key of Object.keys(params)) {
        metadata.set(key, params[key]);
    }
    return metadata;
};
exports.getMetadata = getMetadata;
//# sourceMappingURL=metadata.js.map